import { Env } from "@stencil/core";
import axios, { AxiosResponse } from "axios";

export const API_PATHS = {
  TRACK_EVENT: 'api/v1/credenciamento/contratacao/click_event',
};

class ServiceBrokerApiCaller {

  private static createAxiosInstance() {
    return axios.create({ baseURL: Env.FINTECH_API_URL });
  }

  public static async callApi(servicePath: string, data: Record<string, unknown>): Promise<Record<string, unknown> | null> {
    const backend = this.createAxiosInstance();
    const config = this.getFintechConfig();

    return backend
      .post(servicePath, data, config)
      .then(response => this.resolveFintechReponse(response, servicePath));
  }

  private static resolveFintechReponse(response: AxiosResponse, serviceName: string): Record<string, unknown> | null {
    const HTTP_SERVICE_BROKER_ERROR_CODES = [ 400, 401, 403, 404, 500];
    const serviceBrokerStatus = response?.status;

    if (HTTP_SERVICE_BROKER_ERROR_CODES.includes(serviceBrokerStatus)) {
      console.error(`[ServiceBrokerApiCaller - callApi()] Erro ao chamar serviço ${serviceName}. Status: ${serviceBrokerStatus}`, response.data);
      throw new Error(`[ServiceBrokerApiCaller - callApi()] Erro ao chamar serviço ${serviceName}. Status: ${serviceBrokerStatus}`);
    }

    return response?.data ?? null;
  }

  private static getFintechConfig() {
    return {
      headers: { Authorization: `Bearer ${Env.FINTECH_API_TOKEN}` }
    };
  }

}

export default ServiceBrokerApiCaller;
